import { LIGHT_SHADOW } from "modules/storyblok/templates/AirHelpScore/styles";
import { Flex } from "@chakra-ui/react";
import type { TopThreeCardProps } from "./TopThreeCard.d";

const TopThreeCard = ({ children }: TopThreeCardProps) => (
  <Flex
    py={10}
    px={8}
    rounded="xl"
    borderColor="greyscale.400"
    bg="white"
    boxShadow={LIGHT_SHADOW}
    textAlign="center"
    flexDir="column"
    justify="center"
  >
    {children}
  </Flex>
);

export default TopThreeCard;
